//import { IWalletProviderContext } from '../../walletprovider/WalletProvider';
import ProfileDataStorage from "./profileDataStorage";
import { fromStorageJson, toStorageJson, createEmptyStorageJson, } from "./storageJsonConvert";
class ProfileJsonStorage {
    profileDataStorage;
    constructor(profileDataStorage) {
        this.profileDataStorage = profileDataStorage;
    }
    static create(avalancheProvider, walletProvider) {
        return new this(new ProfileDataStorage(avalancheProvider, walletProvider));
    }
    async get() {
        const data = await this.profileDataStorage.get();
        if (data === undefined) {
            return undefined;
        }
        const jsonObj = fromStorageJson(data);
        return jsonObj;
    }
    async set(toStore) {
        const data = toStorageJson(toStore);
        await this.profileDataStorage.set(data);
    }
    async hasData() {
        return this.profileDataStorage.hasData();
    }
    async delete() {
        this.profileDataStorage.delete();
    }
    async getDataForAddress(key) {
        const data = await this.profileDataStorage.getDataForAddress(key);
        if (data === undefined) {
            return undefined;
        }
        const jsonObj = fromStorageJson(data);
        return jsonObj;
    }
    async updateDataForAddress(key, newValuesToStore) {
        let storedObj = await this.getDataForAddress(key);
        if (storedObj == undefined) {
            storedObj = createEmptyStorageJson();
        }
        const jsonObj = { ...storedObj, ...newValuesToStore };
        await this.setDataForAddress(key, jsonObj);
    }
    async setDataForAddress(key, toStore) {
        const data = toStorageJson(toStore);
        await this.profileDataStorage.setDataForAddress(key, data);
    }
    async hasDataForAddress(key) {
        return this.profileDataStorage.hasDataForAddress(key);
    }
    async deleteForAddress(key) {
        this.profileDataStorage.deleteForAddress(key);
    }
}
export default ProfileJsonStorage;
